import axios from "axios";
const host = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");
const id = localStorage.getItem("id");

export async function fetchUserApi() {
  const res = await axios.get(`${host}api/user/info/${id}`, {
    headers: {
      token,
    },
  });
  /*
  const res = await axios({
    url: host + "api/user/info/" + String(id),
    method: "GET",
    headers: { token: token },
  });
  */
  return res;
}

export async function fetchisInductedApi(data) {
  const res = await axios.post(`${host}api/user/isInducted`, data, {
    headers: {
      token,
    },
  });
  /*
  const res = await axios({
    url: host + "api/user/isInducted",
    method: "POST",
    headers: { token: token },
    data,
  });*/
  return res;
}

export async function fetchUpdateDomainsApi(data) {
  const res = await axios.post(`${host}api/user/updateDomain`, data, {
    headers: {
      token,
    },
  });
  /*
  const res = await axios({
    url: host + "api/user/updateDomain",
    method: "POST",
    headers: { token: token },
    data,
  });*/
  return res;
}